export default class NeocomAIChat {
    public static checkAndDisplayChatBubble(): void {
        const globalWindow = window as any;

        if (
            globalWindow.isNeocomAIChatImplicitCookieConsent === '1'
            && globalWindow.Neocom
            && typeof globalWindow.Neocom.showChatBubble === "function"
        ) {
            globalWindow.Neocom.showChatBubble(globalWindow.neocomAssistantId, globalWindow.neocomConfig);
        }
    }
}
